import './Logo.css'
import { FC } from "react"

export const Logo: FC = () => {
  return (
      <img className="Logo" src="https://storage.googleapis.com/simonadelstyle/logo-white.png" />
  )
}
